<template>
  <nav class="hidden lg:flex items-center h-[48px] px-3 gap-0.5 bg-white dark:bg-gray-800">

    <!-- Loader -->
    <div v-if="loading" class="flex items-center gap-2 text-gray-400 text-xs px-2">
      <Icon icon="mdi:loading" class="animate-spin" width="16" height="16" />
      Cargando...
    </div>

    <!-- Sin menú -->
    <div v-else-if="menuTree.length === 0" class="text-xs text-gray-400 italic px-2">
      Sin módulos
    </div>

    <!-- Árbol de menú HORIZONTAL -->
    <template v-else>
      <MenuNode
        v-for="item in modulosVisibles"
        :key="item.id"
        :item="item"
        :collapsed="false"
        :level="0"
        :active-section="activeSection"
        orientation="horizontal"
        @item-click="handleItemClick"
        @section-opened="handleSectionOpened"
      />

      <!-- Botón "Más" -->
      <div v-if="modulosOcultos.length > 0" class="relative ml-auto flex-shrink-0">
        <button
          @click.stop="toggleMasMenu"
          class="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[12px] font-medium transition-colors whitespace-nowrap"
          :class="[
            masMenuAbierto
              ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300'
              : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
          ]"
        >
          <Icon icon="mdi:dots-vertical" width="16" height="16" />
          <span>Más</span>
          <span class="ml-1 text-[10px] bg-red-500 text-white rounded-full px-1.5 py-0.5 font-bold">
            {{ modulosOcultos.length }}
          </span>
        </button>

        <transition
          enter-active-class="transition duration-150 ease-out"
          enter-from-class="opacity-0 -translate-y-1"
          enter-to-class="opacity-100 translate-y-0"
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 -translate-y-1"
        >
          <div
            v-if="masMenuAbierto"
            class="absolute top-full right-0 mt-1 min-w-[220px] max-w-[90vw] bg-white dark:bg-gray-800 rounded-lg shadow-2xl border border-gray-100 dark:border-gray-700 py-1 z-[300] max-h-[70vh] overflow-y-auto"
          >
            <MenuNode
              v-for="item in modulosOcultos"
              :key="item.id"
              :item="item"
              :collapsed="false"
              :level="0"
              :active-section="activeSection"
              orientation="horizontal"
              :force-vertical="true"
              @item-click="handleItemClickCerrado"
              @section-opened="handleSectionOpened"
            />
          </div>
        </transition>
      </div>
    </template>
  </nav>
</template>

<script>
import { Icon } from "@iconify/vue";
import MenuNode from "./MenuNode.vue";

export default {
  name: 'SidebarMenu',
  components: { Icon, MenuNode },
  props: {
    collapsed: { type: Boolean, default: false },
    menuTree:  { type: Array,   default: () => [] },
    loading:   { type: Boolean, default: false },
  },
  data() {
    return {
      activeSection: null,
      masMenuAbierto: false,
      limiteVisibles: 8,
    };
  },
  computed: {
    modulosVisibles() {
      const lista = Array.isArray(this.menuTree) ? this.menuTree.filter(Boolean) : [];
      return lista.length <= this.limiteVisibles
        ? lista
        : lista.slice(0, this.limiteVisibles);
    },
    modulosOcultos() {
      const lista = Array.isArray(this.menuTree) ? this.menuTree.filter(Boolean) : [];
      return lista.length <= this.limiteVisibles
        ? []
        : lista.slice(this.limiteVisibles);
    }
  },
  mounted() {
    document.addEventListener('click', this.cerrarMasMenuSiClickFuera);
  },
  // ✅ Vue 3: beforeDestroy ya no existe, es beforeUnmount
  beforeUnmount() {
    document.removeEventListener('click', this.cerrarMasMenuSiClickFuera);
  },
  methods: {
    toggleMasMenu() { this.masMenuAbierto = !this.masMenuAbierto; },
    cerrarMasMenuSiClickFuera(e) {
      if (!this.masMenuAbierto) return;
      if (e.target.closest('.relative.ml-auto')) return;
      this.masMenuAbierto = false;
    },
    handleItemClickCerrado(item) {
      this.handleItemClick(item);
      this.masMenuAbierto = false;
    },
    handleSectionOpened(sectionName) { this.activeSection = sectionName; },
    handleItemClick(item) {
      if (!item) return;
      if (item.ruta && /^https?:\/\//i.test(item.ruta)) {
        window.open(item.ruta, '_blank', 'noopener');
      }
    },
  }
};
</script>